<script>
import {
  rexDropdown
} from '@/components/views/rexField'
import sortTrigger from '@/assets/images/icons/sort-alt.svg?inline'

export default {
  name: 'search-results-controls',
  components: {
    rexDropdown,
    sortTrigger
  },
  props: {
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    targetSortingOrder: {
      type: String,
      default: () => null,
      required: true
    },
    targetSortingField: {
      type: String,
      default: () => null
    },
    targetPreset: {
      type: String,
      default: () => null,
      required: true
    },
    presetSetter: {
      type: String,
      default: () => null,
      required: true
    },
    presets: {
      type: Array,
      default: () => null
    },
    sortOrderKeys: {
      type: Array,
      default: () => ['ASC', 'DESC']
    },
    sortFields: {
      type: Array,
      default: () => [
        {
          name: 'По дате создания',
          slug: 'createDate'
        },
        {
          name: 'По дате заезда',
          slug: 'startDate'
        }
      ]
    },
    isSortFieldsSelect: {
      type: Boolean,
      default: () => true
    },
    sortFieldName: {
      type: String,
      default: () => null
    }
  },
  computed: {
    preset: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.targetPreset)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.targetPreset,
          value
        })

        const preset = this.presets.find(item => item.slug === value).form

        this.$store.commit(`${this.storeModule}/${this.presetSetter}`, preset)

        this.$emit('presetChanged', value)
      }
    },
    sortOrder: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.targetSortingOrder)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.targetSortingOrder,
          value
        })

        this.$emit('sortOrderChanged', value)
      }
    }
  },
  methods: {
    sortFieldChanged() {
      this.$emit('sortFieldChanged')
    },
  }
}
</script>
<template>
  <div class="search-results-controls">
    <div class="search-results-controls__presets-list">
      <b-radio
        v-for="item in presets"
        :key="item.slug"
        v-model="preset"
        name="preset"
        class="search-results-controls__presets-list-item"
        :class="{
          'search-results-controls__presets-list-item--selected': preset === item.slug
        }"
        :native-value="item.slug"
      >
        {{ item.name }}
      </b-radio>
    </div>
    <div class="search-results-controls__sort">
      <rex-dropdown
        v-if="isSortFieldsSelect"
        name="searchResultsControlsSortField"
        :store-module="storeModule"
        :getter-name="getterName"
        :setter-name="setterName"
        :target="targetSortingField"
        position="is-bottom-left"
        :data="sortFields"
        @onChange="sortFieldChanged"
      />
      <div
        v-else
        class="search-results-controls__sort-field-name"
      >
        {{ sortFieldName }}
      </div>
      <b-switch
        v-model="sortOrder"
        :true-value="sortOrderKeys[0]"
        :false-value="sortOrderKeys[1]"
      >
        <sort-trigger
          class="search-results-controls__sort-trigger"
          :class="{
            'search-results-controls__sort-trigger--ascending': sortOrder === sortOrderKeys[0]
          }"
        />
      </b-switch>
    </div>
  </div>
</template>
